import { Divider, Typography } from '@tunasong/ui-lib'
import { MusicTheory, ScaleSelect } from '@tunasong/music-ui'
import type { Scale } from '@tunasong/schemas'
import { useState } from 'react'

export const MusicTheoryPage = () => {
  const [scale, setScale] = useState<Scale | null>({ root: 'C', type: 'major' })

  return (
    <div style={{ padding: 32, overflow: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Select a Scale
      </Typography>
      <ScaleSelect value={scale} onChange={setScale} allowNone={false} />
      <Divider style={{ marginTop: 16, marginBottom: 16 }} />
      {scale && <MusicTheory scale={scale} />}
    </div>
  )
}

export default MusicTheory
